import { render } from "./terms-of-service.vue?vue&type=template&id=4968a660&scoped=true"
import script from "./terms-of-service.vue?vue&type=script&lang=js"
export * from "./terms-of-service.vue?vue&type=script&lang=js"

import "./terms-of-service.vue?vue&type=style&index=0&id=4968a660&lang=scss&scoped=true"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4968a660"]])

export default __exports__